<i18n lang="yaml">
zh:
  energy_detail: "能量明细"
  acquire: "获取"
  consume: "消耗"
  time: "时间"
  type: "类型"
  acquire_energy: "获取能量"
  consume_energy: "消耗能量"
  remark: "备注"
  detail: "详情"
  no_purchase_record: "还没有购买记录"
  confirm_delete: "确定删除吗?"
  confirm: "确定"
  cancel: "取消"
en:
  energy_detail: "Energy Details"
  acquire: "Acquire"
  consume: "Consume"
  time: "Time"
  type: "Type"
  acquire_energy: "Acquired Energy"
  consume_energy: "Consumed Energy"
  remark: "Remark"
  detail: "Detail"
  no_purchase_record: "No purchase record yet"
  confirm_delete: "Are you sure to delete?"
  confirm: "Confirm"
  cancel: "Cancel"
</i18n>
<template>
<div style="padding: 1rem 1rem;">
  <div class="d-flex flex-between flex-y-center writer-energy-box" style="">
    <div class="writer-energy-box-title" style="">
      {{$t('energy_detail')}}
    </div>
    <div class="writer-energy-box-right" style="">
      <span class="writer-energy-box-right-item" :class="{'writer-energy-box-right-item-active': sliderBoxActive == 0}" style="" @click="itemClick(0)">
        {{$t('acquire')}}
      </span>
      <span class="writer-energy-box-right-item" :class="{'writer-energy-box-right-item-active': sliderBoxActive == 1}" style="" @click="itemClick(1)">
        {{$t('consume')}}
      </span>
    </div>
  </div>
  <!-- 数据表格 -->
  <el-table
    :header-cell-style="{background:'#E5EEFE', color:'rgba(0,0,0,0.4)','font-weight': 400}"
    :row-style="rowStyle"
    :data="tableData"
    :highlight-current-row="false"
    @cell-mouse-enter="cellMouseEnter"
    ref="tableContainer"
    class="table-container">

    <el-table-column
      prop="createTime"
      :label="$t('time')"
      width="200"/>

    <el-table-column v-if="sliderBoxActive==0"
      prop="profitTypeLabel"
      :label="$t('type')"
      width="250" >
      <template slot-scope="scope">
        <span style="">
          {{scope.row.profitTypeLabel}}
        </span>
      </template>
    </el-table-column>

    <el-table-column v-else
      prop="workflowNodeTitle"
      :label="$t('type')"
      show-overflow-tooltip
      min-width="100" >
      <template slot-scope="scope">
        <span style="">
          {{ scope.row.profitType=='PER_DAY_GIVE_RETURN'?scope.row.profitTypeLabel:scope.row.workflowNodeTitle}}
        </span>
      </template>
    </el-table-column>

    <el-table-column v-if="sliderBoxActive==0"
      prop="amount"
      :label="$t('acquire_energy')"
      width="100" >
      <template slot-scope="scope">
        <span style="">
          {{scope.row.profitType!='FREE'?scope.row.amount:''}}
        </span>
      </template>
    </el-table-column>
    <el-table-column v-else
      prop="amount"
      :label="$t('consume_energy')"
      width="80" >
      <template slot-scope="scope">
        <span style="">
          {{scope.row.amount}}
        </span>
      </template>
    </el-table-column>
    <el-table-column min-width="40px" v-if="sliderBoxActive==1" :label="$t('remark')" align="center">
      <template slot="header">
      </template>
      <template slot-scope="scope">
        <span v-if="scope.row.profitType=='PER_DAY_GIVE_RETURN'"></span>
        <el-button v-else @click="rowClick(scope.row)" size="mini" type="primary" round plain>{{$t('detail')}}</el-button>
      </template>
    </el-table-column>
    <el-table-column v-else
      prop="remark"
      :label="$t('remark')"
      min-width="40px" />

  </el-table>
<!--  <el-empty v-if="tableData.length==0" image="https://www.creatimix.com/static/empty.jpg" :description="$t('no_purchase_record')" style="margin: 0 auto;">
    <p style="margin: 0;color: rgba(0,0,0,0.6);font-size: 14px;">Start your journey!</p>
  </el-empty> -->

  <el-row>
    <el-col>
      <div class="pagination">
        <el-pagination background
          hide-on-single-page
          :page-sizes="paginations.pages"
          :page-size="paginations.size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page.sync="paginations.current"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-col>
  </el-row>

  <WorkflowNodeForm v-if="control.show" :control="control" :enums="enums"/>
</div>
</template>
<script>
import * as AccounntProfitLogApi from '@/api/accountprofitlog'
import { mapState, mapMutations} from 'vuex'
import WorkflowNodeForm from './form'
export default {
  name: 'Energy',
  components: {
    WorkflowNodeForm
  },
  data() {
    return {
      sliderBoxActive: 0,
      fromType: 'writer_client',
    	targetPermit: 'profit',
      queryForm: {
        incomeFlag: true,
        fromType: 'writer-web',
        current: '',
        size: 20
      },
      control: {
        show: false,
        title: '',
        action: this.$permits.VIEW,
        form: '',
        disabled: false
      },
      enums: [],
      tableData: [],
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 20, // 每页行数
        // sizes: [20], // 每页行数 调整
        layout: 'total, prev, pager, next' // 翻页属性
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    this.handlePage()
  },
  computed: {
  	...mapState(['user', 'story'])
  },
  methods: {
    ...mapMutations(['setStory', 'setShowDialogFlag']),
    handleRemove(item) {
      this.$confirm('', this.$t('confirm_delete'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        center: true
      }).then(() => {
        OrderApi.remove(item.id).then(res => {
          this.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    rowStyle(){
      return {}
      // if(this.sliderBoxActive == 1){
      //   return {cursor: 'pointer'}
      // }else{
      //   return {}
      // }
    },
    rowClick(row, column, event){
      if(this.sliderBoxActive == 0){
        return false
      }
      console.log('row', row, column, event);
      this.control.show = true
      this.control.form = row
    },
    cellMouseEnter(row, column, cell, event){

    },
    itemClick(index){
      this.sliderBoxActive = index
      this.tableData = []
      this.handlePage()
    },
    handlePage(current) {
      let that = this;
      if (current) {
        that.paginations.current = current
      }
      that.queryForm.incomeFlag = that.sliderBoxActive == 0
      that.queryForm.current = that.paginations.current
      that.queryForm.size = that.paginations.size
      console.log('workspace index user', this.user);
      if(!this.user || !this.user.id){
        return false;
      }
      that.queryForm.accountId = this.user.id
      // 获取表格数据
      AccounntProfitLogApi.page(that.queryForm).then(res => {
        let result = res.data.data;
        that.tableData = result.records
        that.paginations.total = Number(result.total)
        that.paginations.current = Number(result.current)
        that.paginations.size = Number(result.size)
      })
    },
    handleCurrentChange(page) {
      // 切换页码
      this.paginations.current = page
      this.handlePage()
    },
    handleSizeChange(size) {
      // 切换size
      this.paginations.size = size
      this.size = size
      this.handlePage()
    }
  }
}
</script>

<style scoped lang="scss">

/* 取消行悬停效果 */
/deep/ .el-table--enable-row-hover {
    background-color: transparent !important;
}

/* 取消行过渡效果 */
/deep/ .el-table--enable-row-transition {
    transition: none !important;
}
/deep/ .el-table th.el-table__cell.is-leaf, /deep/ .el-table td.el-table__cell {
  border-bottom: none;
}
/deep/ td.el-table__cell {
  background-color: transparent !important;
}
// .el-table--enable-row-transition
/deep/ .el-table__row:hover{
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  background-color: #366EF4 !important;
}
/deep/ .el-button--mini.is-round {
    padding: 5px 15px;
}
// .writer-energy-box
.writer-energy-box{
  margin-bottom: 1rem;
  &-title {
    font-weight: 400;
    font-size: 20px;
    color: rgba(0,0,0,0.8);
  }
  &-right{
    background: #E5EEFE;
    border-radius: 20px;
    color: rgba(0,0,0,0.9);
    font-size: .8rem;
    line-height: 1.8rem;
    &-item {
      padding: .25rem 1rem;
      cursor: pointer;
      &-active{
        background: #0052D9;
        color: rgba(255,255,255,0.9);
        border-radius: 20px;
      }
    }
  }
}

.table-container {
  margin-bottom: 1rem;
  /deep/ .el-table__body {
    border-spacing: 0 10px !important;
    border-radius: 20px;
    width: auto !important;
  }
  /deep/ .el-table__body-wrapper.is-scrolling-left{
    width: auto !important;
  }
  /deep/ .el-table__body-wrapper .el-table__empty-block {
    width: auto !important;
  }
}
</style>
